import React, { useCallback, useState } from 'react';

import { FaWhatsapp, FaCheckCircle, FaSpinner, FaCircle } from 'react-icons/fa';
import { Button } from 'react-bootstrap';

import api from '../../../../services/api';

import { useToast } from '../../../../hooks/toast';

import { Spinner } from '../../../../components/Agendamento/styles';

import getResponseErrors from '../../../../utils/getResponseErrors';

import { IPaciente } from '../index';
import { htmlDecode, ORIGEM_NOTIFICACAO } from '../../../../utils/funcoes';

type ITemTabela = {
  paciente: IPaciente;
  conectado: boolean;
};

const ItemTabela: React.FC<ITemTabela> = ({ paciente, conectado }) => {
  const { addToast } = useToast();

  const [loading, setLoading] = useState(false);
  const [conferido, setConferido] = useState(paciente.conferido);

  const handleSalvaNotificacao = useCallback(async () => {
    try {
      setLoading(true);
      if (!conferido) {
        await api.post(`pacientes/aniversariantes`, {
          RegPacCodigo: paciente.PacCodigo,
        });
      } else {
        await api.delete(`pacientes/aniversariantes/${paciente.PacCodigo}`);
      }

      setConferido(!conferido);
    } catch (error) {
      const mensagemErro = getResponseErrors(error);
      addToast({
        title: 'Não foi possível salvar a notificação',
        type: 'error',
        description: mensagemErro,
      });
    } finally {
      setLoading(false);
    }
  }, [addToast, conferido, paciente.PacCodigo]);

  const handleEnviaConfirmacao = useCallback(
    async (pacient: IPaciente) => {
      if (!conectado) {
        const textoDecode = htmlDecode(pacient.textoMensagem);
        const textoMensagem = encodeURIComponent(textoDecode);

        console.log(pacient.textoMensagem, textoDecode, textoMensagem);
        const linkWhatsapp = `https://api.whatsapp.com/send?phone=55${pacient.PacCelular}&text=${textoMensagem}`;
        window.open(linkWhatsapp, '_blank');
      }
      if (conectado) {
        const { textoMensagem } = pacient;

        try {
          setLoading(true);
          const dados = {
            message: textoMensagem,
            type: ORIGEM_NOTIFICACAO.ANIVERSARIANTES,
            numeroTo: `55${pacient.PacCelular}`,
            // numeroTo: `5524981158580`,
          };

          const retornoEnvio = await api.put(
            `/whatsapp/sendmessage/${pacient.PacCodigo}`,
            dados,
          );
          if (retornoEnvio.data.error === true) {
            addToast({
              title: 'Não foi possível salvar a notificação',
              type: 'error',
              description: retornoEnvio.data.message,
            });
          } else {
            setConferido(true);
          }
        } catch (error) {
          const mensagemErro = getResponseErrors(error);
          addToast({
            title: 'Não foi possível salvar a notificação',
            type: 'error',
            description: mensagemErro,
          });
        } finally {
          setLoading(false);
        }
      }
    },
    [addToast, conectado],
  );

  return (
    <>
      <tr
        style={{
          fontSize: 'Small',
          height: '30px',
        }}
      >
        <td>{paciente.PacNome}</td>
        <td>{paciente.PacDataNascFormatado}</td>
        <td>{paciente.idade}</td>
        <td>{paciente.dataUltimaConsultaFormatado}</td>
        <td>{paciente.telefoneFormatado}</td>
        <td>{paciente.PacEmail}</td>
        <td style={{ textAlign: 'center' }}>
          <Button
            type="button"
            variant="success"
            size="sm"
            onClick={() => handleEnviaConfirmacao(paciente)}
          >
            <FaWhatsapp size={16} />
          </Button>
        </td>
        <td>
          {loading ? (
            <Spinner className="px-2 py-1 border rounded ml-1">
              <FaSpinner size={17} />
            </Spinner>
          ) : (
            <Button
              type="button"
              variant={conferido ? 'success' : 'outline-secondary'}
              size="sm"
              data-id={paciente.PacCodigo}
              onClick={() => handleSalvaNotificacao()}
            >
              {conferido ? <FaCheckCircle size={16} /> : <FaCircle size={16} />}
            </Button>
          )}
          {/* <Conferido
            PacCodigo={paciente.PacCodigo}
            conferido={paciente.conferido}
          /> */}
        </td>
      </tr>
    </>
  );
};

export default ItemTabela;
